export enum RecaptchaType {
    REGISTER = "register",
    LOGIN = "login",
    PASSWORD_RESET = "password_reset"
  }
  